export const environment = {
  production: false,
  msal: {
    clientId: 'cd5c24a4-5c60-496a-b430-77b68a117014',
    redirectUrl: 'https://firmenstammdaten.persona-test123.de/',
    authority:
      'https://login.microsoftonline.com/1c2b8ed7-dafe-4820-ab1e-23ce67c5326e'
  },
  requiredScopes: ['api://tst-firmenstammdaten-bol/.default'],
  apiHost: 'https://apim-tst.api.persona.de',
  apiBaseUrl: 'tst-firmenstammdaten-bol/v1/api/rest/v1'
};
